import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import {
  GET_NOTIFICATION_TEMPLATES,
  GET_TRIGGER_CONTRACTS,
  PREVIEW_NOTIFICATION_TEMPLATE,
  SAVE_NOTIFICATION_TEMPLATE,
  DEACTIVATE_NOTIFICATION_TEMPLATE,
  SEND_ADMIN_NOTIFICATION,
} from "../graphql";
import type {
  NotificationTemplate,
  TriggerContract,
  NotificationPreview,
  SaveNotificationTemplateInput,
  SendAdminNotificationInput,
} from "../types";

// ─── Queries ─────────────────────────────────────────────────────────────────

export function useNotificationTemplates(isActive?: boolean) {
  return useQuery<{ notificationTemplates: NotificationTemplate[] }>(
    GET_NOTIFICATION_TEMPLATES,
    {
      variables: { isActive },
      fetchPolicy: "cache-and-network",
    },
  );
}

export function useTriggerContracts() {
  return useQuery<{ notificationTriggerContracts: TriggerContract[] }>(
    GET_TRIGGER_CONTRACTS,
    { fetchPolicy: "cache-and-network" },
  );
}

export function usePreviewTemplate() {
  return useLazyQuery<{ previewNotificationTemplate: NotificationPreview }>(
    PREVIEW_NOTIFICATION_TEMPLATE,
    { fetchPolicy: "no-cache" },
  );
}

// ─── Mutations ───────────────────────────────────────────────────────────────

export function useSaveNotificationTemplate() {
  return useMutation<
    { saveNotificationTemplate: NotificationTemplate },
    { input: SaveNotificationTemplateInput }
  >(SAVE_NOTIFICATION_TEMPLATE, {
    refetchQueries: ["NotificationTemplates"],
  });
}

export function useDeactivateNotificationTemplate() {
  return useMutation<
    { deactivateNotificationTemplate: boolean },
    { name: string; locale: string }
  >(DEACTIVATE_NOTIFICATION_TEMPLATE, {
    refetchQueries: ["NotificationTemplates"],
  });
}

export function useSendAdminNotification() {
  return useMutation<
    { sendAdminNotification: boolean },
    { input: SendAdminNotificationInput }
  >(SEND_ADMIN_NOTIFICATION);
}
